import { render, staticRenderFns } from "./BuscaAnoTurmaDisciplina.vue?vue&type=template&id=307b8fa9&"
import script from "./BuscaAnoTurmaDisciplina.vue?vue&type=script&lang=js&"
export * from "./BuscaAnoTurmaDisciplina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports